import React from 'react';
import { InstagramIcon, YoutubeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TikTokIcon } from './icons/TikTokIcon';
export function Footer() {
  return <footer className="w-full bg-neutral-900 px-4 pb-3 pt-5 text-neutral-300 sm:px-6" data-id="element-212" data-mp="32o4d0g3lai96">
      <div className="mx-auto flex max-w-[1300px] flex-col gap-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-213" data-mp="36pfu1x8edv5r">
        <div className="flex items-center gap-3" data-id="element-214" data-mp="3ueijvsd6qubc">
          <img src="https://cdn.magicpatterns.com/uploads/dVxge7E5WrZsG2Xk4nm9RJ/image.png" alt="Logo der Sales Academy" className="h-10 w-10 rounded-full object-contain" data-id="element-215" data-mp="3uftmhouw9w0v" />
          <span className="text-sm font-semibold uppercase tracking-widest text-white" data-id="element-216" data-mp="3lgooqkr5q6pr">
            Hot Sales Girls<sup className="ml-0.5 text-[1.45em] leading-none" style={{
            verticalAlign: 'baseline',
            position: 'relative',
            top: '-0.06em'
          }} data-id="element-217" data-mp="3qf9s2t1ph6if">
              ®
            </sup>
          </span>
        </div>

        <nav aria-label="Footer" className="grid grid-cols-2 gap-x-6 gap-y-2 text-center text-sm lg:flex lg:items-center lg:gap-8" data-id="element-218" data-mp="3lalhljipadw2">
          <Link to="/ablauf" className="hover:text-white" data-id="element-219" data-mp="3v7q6vs7ueph3">
            Ablauf der Academy
          </Link>
          <Link to="/about-me" className="hover:text-white" data-id="element-220" data-mp="3q8wphopfqebn">
            About Me
          </Link>
          <Link to="/impressum" className="hover:text-white" data-id="element-221" data-mp="82qtvx6261vu">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-white" data-id="element-222" data-mp="3472hh8p3xw3">
            Datenschutz
          </Link>
        </nav>

        <div className="flex items-center gap-3" data-id="element-223" data-mp="ht3axfenzcx8">
          <a href="https://www.instagram.com/tina_xla/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700" data-id="element-224" data-mp="huwlv6wb8jb1">
            <InstagramIcon className="h-5 w-5" aria-hidden="true" data-id="element-225" data-mp="mptrs4yamcjp" />
          </a>
          <a href="https://www.tiktok.com/@tina_xla?_t=ZN-8tHLLH6ugD8&_r=1" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700" data-id="element-226" data-mp="two07ivoux21">
            <TikTokIcon className="h-5 w-5" data-id="element-227" data-mp="18m3sj3avbaju" />
          </a>
          <a href="https://www.youtube.com/@tina_xla" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700" data-id="element-228" data-mp="1ckkpiu0kr4nj">
            <YoutubeIcon className="h-5 w-5" aria-hidden="true" data-id="element-229" data-mp="1rhtuwrmpq8y9" />
          </a>

        </div>
      </div>

      <p className="mx-auto mt-3 max-w-[1300px] text-center text-xs text-neutral-500" data-id="element-230" data-mp="3oc6r0y0g4zzi">
        © 2026 Mermaid Beauty Aesthetics FZCO. Alle Rechte vorbehalten.
      </p>
    </footer>;
}